// extracted by mini-css-extract-plugin
export default {"companiesChecklist":"companiesChecklistQBPJ4"};